import React, { useEffect, useRef, useState } from "react";
import tw from "twin.macro";
import {
  getAddToCart,
  getBranchId,
  getBranchName,
  getCustomerId,
  getEstimationId,
  setEstimationId,
  setPaymentUrl,
} from "utility/HeaderConfig";
import moment from "moment";
import { motion } from "framer-motion";
import { getProduct } from "api/ProductApi";
import { Link, useNavigate } from "react-router-dom";
import success from "images/OrderStatus/success.gif";
import decline from "images/OrderStatus/decline.gif";
import { useLocation } from "react-router-dom";
import { SALES_ACCOUNTS, utcDateToCurrentDate } from "../utility/Constant";
import ShippingAddress from "components/ShippingAddress";
import OrderDetails from "components/OrderDetails";
import { toast } from "react-hot-toast";
import { filterFormatToDate } from "utility/Constant";
import { useCartContext } from "context/UseCartContext";
import CheckoutProgressBar from "components/CheckoutProgressBar";
import ChoosePaymentMethod from "components/ChoosePaymentMethod";
import {
  ECommerce,
  getCcavenueOrderStatusData,
  getCcavenuePaymentLinkData,
} from "../api/AppConfigApi";
import {
  getAllExpenseCategory,
  getAllPaymentMode,
  getByLedgerName,
} from "../api/CheckOutApi";
import { getAllDomainEmployeeDetails } from "../api/EmployeeApi";
import {
  createEstimationData,
  getDayCloseData,
  getDefaultFinancialYr,
  getOrderStatusId,
} from "../utility/UtilFunction";
import { createSaleItems } from "../utility/CreateSale";
import {
  getInvoiceId,
  setAddToCart,
  setInvoiceId,
} from "../utility/HeaderConfig";
import { useVisibilityChange } from "hooks/useVisibilityChange";
import "styles/checkout.css";

const CART_SESSION_KEY = "checkout_cart_state";

const saveCartToSession = (viewCart, total) => {
  try {
    sessionStorage.setItem(
      CART_SESSION_KEY,
      JSON.stringify({ viewCart, total }),
    );
  } catch (_) {}
};

const loadCartFromSession = () => {
  try {
    const raw = sessionStorage.getItem(CART_SESSION_KEY);
    if (raw) return JSON.parse(raw);
  } catch (_) {}
  return { viewCart: [], total: 0 };
};

const StyledDiv = tw.div`font-display overflow-hidden`;
const BgColor = tw.div`bg-zinc-100 py-4 sm:py-10`;
export const NavLink = tw.a`no-underline`;

export default function CheckoutPage() {
  // eslint-disable-next-line
  const documentVisibility = useVisibilityChange();

  const [address, setAddress] = useState(true);
  const [payment, setPayment] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [Details, setDetails] = useState({
    customerName: "",
    mobileNo: "",
    email: "",
    address1: "",
    address2: "",
    pincode: "",
    landmark: "",
    districtName: "",
    stateName: "",
    countryName: "",
    customerId: "",
    customerCurrentCredit: 0,
    customerCurrentDebit: 0,
  });

  const location = useLocation();
  const myparam = location.state; // eslint-disable-line
  const history = useNavigate();

  const stateFromLocation = {
    viewCart: location.state?.viewCart || [],
    total: location.state?.total || 0,
  };
  const stateFromSession = loadCartFromSession();

  const viewCart =
    stateFromLocation.viewCart.length > 0
      ? stateFromLocation.viewCart
      : stateFromSession.viewCart;

  const total =
    stateFromLocation.total > 0
      ? stateFromLocation.total
      : stateFromSession.total;

  useEffect(() => {
    if (viewCart.length > 0 && total > 0) {
      saveCartToSession(viewCart, total);
    }
    // eslint-disable-next-line
  }, []);

  const [saleId, setSaleId] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [orderStatusDetails, setOrderStatusDetails] = useState({
    order_card_name: "UPI",
  });
  const [orderStatusValue, setOrderStatusValue] = useState("");
  const [paymentModeList, setPaymentModeList] = useState([]);
  const [onlinePaymentEmplyId, setOnlinePaymentEmplyId] = useState("");
  const [invoiceExCategoryId, setInvoiceExCategoryId] = useState("");
  const [defaultFinalFinancialYr, setDefaultFinalFinancialYr] = useState("");
  const [soldOrderStatusId, setSoldOrderStatusId] = useState("");
  const [ledgerNameDetails, setLedgerNameDetails] = useState({
    primaryGroupId: "",
    subGroupId: "",
    ledgerNameId: "",
    ledgerName: "",
  });

  const isSaleProcessingElement = useRef(false);
  const [saleDayCloseDate, setSaleDayCloseDate] = useState("");
  const [estiDayCloseDate, setEstiDayCloseDate] = useState("");
  const [estiOrderStatusId, setEstiOrderStatusId] = useState("");
  const [estiCompOrderStatusId, setEstiCompOrderStatusId] = useState("");
  const [paymentRedirectUrl, setPaymentRedirectUrl] = useState("");

  useEffect(() => {
    getCartList();
    getPaymentModeList();
    getOnlinePaymentEmployeeId();
    getExpenseCategoryId();
    getDefaultFinalcialYrId();
    getSoldStatusId();
    getLedgerNameDetails();
    getSaleDayCloseDate();
    getEstiDayCloseDate();
    getEstiOrderStatusId();
    getEstiCompletedOrderStatusId();
    //eslint-disable-next-line
  }, []);

  // Add effect to listen for page visibility changes (when user returns from payment page)
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        const invoiceId = JSON.parse(getInvoiceId())?.invoiceId;
        if (invoiceId && !paymentStatus) {
          checkOrderStatus(invoiceId);
        }
      }
    };
    
    document.addEventListener('visibilitychange', handleVisibilityChange);
    
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [paymentStatus]);

  const viewCartList = () => {
    let totalAmount = 0;
    const newArray =
      getAddToCart() &&
      JSON.parse(getAddToCart()).filter(
        (cartItem) => cartItem.branch === getBranchId(),
      );
    if (newArray?.length > 0) {
      newArray.forEach((element, index) => {
        let filter = {
          branch: getBranchId(),
          id: element.id,
          beforeCreatedAt: filterFormatToDate(moment().format("YYYY-MM-DD")),
        };
        getProduct(10, filter).then((res) => {
          if (res.response.content.length > 0) {
            newArray[index].images = res.response.content[0].images;
            newArray[index].total = res.response.content[0].total;
            totalAmount += Math.trunc(res.response.content[0].total);
            saveCartToSession(newArray, totalAmount);
          }
        });
      });
    }
  };

  const getCartList = () => {
    viewCartList();
  };

  const getPaymentModeList = () => {
    getAllPaymentMode().then((data) => setPaymentModeList(data.response));
  };

  const getOnlinePaymentEmployeeId = () => {
    getAllDomainEmployeeDetails({ name: "ONLINEPAYMENT" }).then((data) => {
      setOnlinePaymentEmplyId(data.response[0].id);
    });
  };

  const getExpenseCategoryId = () => {
    getAllExpenseCategory({ name: "invoice" }).then((data) => {
      setInvoiceExCategoryId(data.response[0].id);
    });
  };

  const getDefaultFinalcialYrId = async () => {
    const res = await getDefaultFinancialYr();
    if (res?.length > 0) setDefaultFinalFinancialYr(res[0].id);
  };

  const getSoldStatusId = async () => {
    const res = await getOrderStatusId("Advance_Without_Delivery");
    if (res?.response?.length > 0) setSoldOrderStatusId(res.response[0].id);
  };

  const getLedgerNameDetails = async () => {
    const res = await getByLedgerName(SALES_ACCOUNTS);
    if (res?.id !== undefined) {
      setLedgerNameDetails({
        primaryGroupId: res.metaLedgerPrimaryGroupId,
        subGroupId: res.metaLedgerSubGroupId,
        ledgerNameId: res.id,
        ledgerName: res.name,
      });
    }
  };

  const getSaleDayCloseDate = async () => {
    const res = await getDayCloseData("sales", getBranchId());
    if (res?.response?.length > 0)
      setSaleDayCloseDate(utcDateToCurrentDate(res.response[0].activeDate));
  };

  const getEstiDayCloseDate = async () => {
    const res = await getDayCloseData("estimation", getBranchId());
    if (res?.response?.length > 0)
      setEstiDayCloseDate(utcDateToCurrentDate(res.response[0].activeDate));
  };

  const getEstiOrderStatusId = async () => {
    const res = await getOrderStatusId("estimation");
    if (res?.response?.length > 0) setEstiOrderStatusId(res.response[0].id);
  };

  const getEstiCompletedOrderStatusId = async () => {
    const res = await getOrderStatusId("estimation_completed");
    if (res?.response?.length > 0) setEstiCompOrderStatusId(res.response[0].id);
  };

  const { dispatch } = useCartContext();

  // Fetch payment configuration data
  const getPaymentConfigurationData = async () => {
    try {
      const appConfigResData = await ECommerce("pg_endpoint_config");
      
      if (appConfigResData && appConfigResData.moduleField) {
        const moduleData = JSON.parse(appConfigResData.moduleField);
        const paymentConfMap = moduleData.paymentConfMap;
        const branchName = getBranchName();
        
        // Get payment config for the current branch
        const branchPaymentConfig = paymentConfMap[branchName] || paymentConfMap['AVM Jewellers'];
        
        if (branchPaymentConfig && branchPaymentConfig.CCAVENUE) {
          // Find redirect_url from CCAVENUE configuration
          const redirectUrlConfig = branchPaymentConfig.CCAVENUE.find(
            item => item.key === 'redirect_url'
          );
          
          if (redirectUrlConfig && redirectUrlConfig.value) {
            setPaymentRedirectUrl(redirectUrlConfig.value);
            return redirectUrlConfig.value;
          }
        }
      }
      return null;
    } catch (error) {
      console.error("Error fetching payment configuration:", error);
      return null;
    }
  };

  // Process successful payment
  const processSuccessfulPayment = async (invoiceId) => {
    try {
      const estimationId = getInvoiceId() ? JSON.parse(getInvoiceId()).estimationId : getEstimationId();
      const estimationDetails = [
        {
          financialYear: defaultFinalFinancialYr,
          id: getEstimationId(),
          reason: null,
          status: estiCompOrderStatusId,
        },
      ];
      
      const saleResult = await createSaleItems(
        estimationDetails,
        viewCart,
        Details,
        paymentModeList,
        defaultFinalFinancialYr,
        ledgerNameDetails,
        onlinePaymentEmplyId,
        soldOrderStatusId,
        invoiceExCategoryId,
        saleDayCloseDate,
        estiDayCloseDate,
        estiOrderStatusId,
        { order_status: 'successful' }
      );
      
      if (saleResult.response.id) {
        setSaleId(saleResult.response.id);
        setPaymentStatus("success");
        setLoading(false);
        setPaymentUrl("");
        setInvoiceId(JSON.stringify({ invoiceId: "" }));
        setAddToCart(JSON.stringify([]));
        dispatch({ type: "ADD", payload: JSON.parse(getAddToCart()) });
        
        /* Clear session cart after successful order */
        sessionStorage.removeItem(CART_SESSION_KEY);
        
        toast.success("Payment successful! Your order has been placed.", {
          duration: 3000,
          position: "top-right",
        });
      }
    } catch (error) {
      console.error("Sale creation error:", error);
      setPaymentStatus("failed");
      setLoading(false);
      toast.error("Payment successful but order creation failed. Contact support.", {
        duration: 5000,
        position: "top-right",
      });
    }
  };

  // Submit CCAvenue payment form
  const submitCCAvenueForm = (encRequest, accessCode) => {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = 'https://secure.ccavenue.com/transaction/transaction.do?command=initiateTransaction';
    form.target = '_self';

    const encRequestField = document.createElement('input');
    encRequestField.type = 'hidden';
    encRequestField.name = 'encRequest';
    encRequestField.value = encRequest;
    form.appendChild(encRequestField);

    const accessCodeField = document.createElement('input');
    accessCodeField.type = 'hidden';
    accessCodeField.name = 'access_code';
    accessCodeField.value = accessCode;
    form.appendChild(accessCodeField);

    document.body.appendChild(form);
    form.submit();
  };

  // Modified OrderStatus function to use redirect_url from config
  const OrderStatus = async () => {
    setLoading(true);
    
    // First fetch payment configuration to get redirect_url
    const redirectUrlFromConfig = await getPaymentConfigurationData();
    
    const saleRelatedDetails = {
      paymentModeList,
      defaultFinalFinancialYr,
      ledgerNameDetails,
      onlinePaymentEmplyId,
      soldOrderStatusId,
      invoiceExCategoryId,
      saleDayCloseDate,
      estiDayCloseDate,
      estiOrderStatusId,
      estiCompOrderStatusId,
    };
    
    const estiRes = await createEstimationData(CartItem, saleRelatedDetails);
    
    if (estiRes.response.id !== "") {
      setEstimationId(estiRes.response.id);
      const randomNum = Math.floor(100000 + Math.random() * 900000).toString();
      
      const requestData = {
        acceptTerms: 'true',
        amount: Math.trunc(total),
        authorizedAmount: Math.trunc(total),
        branchId: getBranchId(),
        branchName: getBranchName(),
        currencyCode: "INR",
        customerEmail: Details.email,
        customerId: Details.customerId,
        customerName: Details.customerName,
        customerPhone: Details.mobileNo,
        gatewayName: "CCAVENUE",
        getwayName: "CCAVENUE",
        orderId: randomNum,
        paymentPurpose: "ECOMM_WEB_SALES",
        productDesc: estiRes.response.id,
        responseUrl: redirectUrlFromConfig || "https://example.com/response",
        retryStatus: "No",
        returnUrl: redirectUrlFromConfig || "https://example.com/return",
        usageFrom: "WEB",
      };
      
      try {
        const paymentResponse = await getCcavenuePaymentLinkData(JSON.stringify(requestData));
        
        if (paymentResponse && paymentResponse.response) {
          const { encRequest, accessCode, invoice_id } = paymentResponse.response;
          
          // Store for order status checking
          setInvoiceId(JSON.stringify({ invoiceId: invoice_id, estimationId: estiRes.response.id }));
          
          // Create and submit CCAvenue form
          submitCCAvenueForm(encRequest, accessCode);
        } else {
          setLoading(false);
          toast.error("Failed to initiate payment. Please try again.", {
            duration: 3000,
            position: "top-right",
          });
        }
      } catch (error) {
        console.error("Payment initiation error:", error);
        setLoading(false);
        toast.error("Payment initiation failed. Please try again.", {
          duration: 3000,
          position: "top-right",
        });
      }
    }
  };

  // Modified checkOrderStatus function
  const checkOrderStatus = async (invoiceId) => {
    setLoading(true);
    try {
      const responseData = await getCcavenueOrderStatusData(invoiceId);
      if (responseData && responseData.response) {
        const orderStatusVal = responseData.response.order_status;
        
        if (orderStatusVal && (orderStatusVal.toLowerCase() === "successful" || 
            orderStatusVal.toLowerCase() === "shipped")) {
          await processSuccessfulPayment(invoiceId);
        } else if (orderStatusVal && (orderStatusVal.toLowerCase() === "unsuccessful" || 
                   orderStatusVal.toLowerCase() === "aborted" || 
                   orderStatusVal.toLowerCase() === "cancelled")) {
          setPaymentStatus(orderStatusVal);
          setLoading(false);
          toast.error(`Payment ${orderStatusVal}. Please try again.`, {
            duration: 3000,
            position: "top-right",
          });
        } else {
          setLoading(false);
        }
      }
    } catch (error) {
      console.error("Error checking order status:", error);
      setLoading(false);
    }
  };

  let CartItem = viewCart.map((data) => ({
    productId: data.id,
    productCode: data.productCode,
    basePrice: data.basePrice,
    tax: data.saleTaxList,
    total: data.total,
    todayRate: data.todayRate,
    ocAmt: data.otherCharge,
  }));

  const changeComponent = (data) => {
    setDetails({ ...Details, ...data, customerId: getCustomerId() });
    setAddress(false);
    setPayment(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const clearSuccessData = () => {
    if (paymentStatus === "success" && saleId !== "") {
      sessionStorage.removeItem(CART_SESSION_KEY);
      history("/MyPurchase", { state: { type: "myorder" } });
    }
  };

  const goToAddAddress = (existingAddress = null) => {
    history("/AddAddress", {
      state: {
        /* Pass cart so AddAddress can echo it back */
        viewCart,
        total,
        /* Pre-fill form if editing */
        ...(existingAddress || {}),
      },
    });
  };

  return (
    <StyledDiv>
      {/* Breadcrumb */}
      <div style={{
        background: "var(--surface-cream)", height: 64,
        display: "flex", alignItems: "center", justifyContent: "space-between",
        padding: "0 24px",
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 12 }}>
          <Link to="/" style={{ color: "#7517b4", textDecoration: "none", fontWeight: 500 }}>Home</Link>
          <span style={{ color: "#c4b5cd" }}>›</span>
          <Link to="/CartPage" style={{ color: "#7517b4", textDecoration: "none", fontWeight: 500 }}>Cart</Link>
          <span style={{ color: "#c4b5cd" }}>›</span>
          <span style={{ fontWeight: 600, color: "#4f3267" }}>{address ? "Shipping" : "Payment"}</span>
        </div>
        <Link
          to="/CartPage"
          style={{
            textDecoration: "none", fontSize: 12,
            border: "1px solid #c48eeb", padding: "6px 14px",
            borderRadius: 8, color: "#7517b4",
            display: "inline-flex", alignItems: "center", gap: 6,
            fontWeight: 600, transition: "all .15s",
          }}
        >
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6"/>
          </svg>
          Back to Cart
        </Link>
      </div>

      <BgColor>
        <div className="container">
          <CheckoutProgressBar address={address} payment={payment} />

          <div className="row" style={{ marginTop: 24, marginBottom: 24 }}>
            {/* ── Left column ── */}
            <div className="col-lg-8 mb-4 mb-lg-0">
              <div style={{
                background: "#fff", borderRadius: 16,
                boxShadow: "0 2px 16px rgba(0,0,0,.06)",
                overflow: "hidden",
                border: "1px solid #f0e9fa",
              }}>
                {/* Card header */}
                <div style={{
                  padding: "18px 24px",
                  borderBottom: "1px solid #f5f0fd",
                  display: "flex", alignItems: "center", gap: 10,
                  background: "#fdfbff",
                }}>
                  <div style={{
                    width: 36, height: 36, borderRadius: "50%",
                    background: "linear-gradient(135deg,#8217b4,#c48eeb)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    flexShrink: 0,
                  }}>
                    {address ? (
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
                      </svg>
                    ) : (
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/>
                      </svg>
                    )}
                  </div>
                  <div>
                    <p style={{ margin: 0, fontSize: 15, fontWeight: 700, color: "#2e215c" }}>
                      {address ? "Shipping Address" : "Payment Details"}
                    </p>
                    <p style={{ margin: 0, fontSize: 11, color: "#98989d" }}>
                      {address ? "Where should we deliver?" : "Complete your secure payment"}
                    </p>
                  </div>
                </div>

                <div style={{ padding: "20px 24px" }}>
                  {viewCart.length > 0 ? (
                    <>
                      {address && (
                        <ShippingAddress
                          onClick={changeComponent}
                          viewCart={viewCart}
                          total={total}
                          onAddAddress={goToAddAddress}
                        />
                      )}
                      {payment && (
                        <ChoosePaymentMethod Loading={Loading} OrderStatus={OrderStatus} />
                      )}
                    </>
                  ) : (
                    <div style={{ textAlign: "center", padding: "48px 24px" }}>
                      <div style={{ width: 80, height: 80, borderRadius: "50%", background: "#f5f0fd", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px" }}>
                        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#8217b4" strokeWidth="1.5">
                          <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/>
                          <path d="M16 10a4 4 0 01-8 0"/>
                        </svg>
                      </div>
                      <h4 style={{ fontSize: 18, fontWeight: 700, color: "#4f3267", margin: "0 0 8px" }}>Your cart is empty</h4>
                      <p style={{ fontSize: 14, color: "#cb8cf8", margin: "0 0 24px" }}>Add some beautiful jewellery to get started</p>
                      <button
                        onClick={() => history("/ProductList")}
                        style={{ display: "inline-flex", alignItems: "center", gap: 8, padding: "12px 28px", background: "linear-gradient(135deg,#8217b4,#c48eeb)", color: "#fff", fontSize: 13, fontWeight: 600, border: "none", borderRadius: 999, cursor: "pointer", letterSpacing: ".04em" }}
                      >
                        Browse Products
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* ── Right column: Order Summary ── */}
            <div className="col-lg-4">
              <div style={{
                background: "#fff", borderRadius: 16,
                boxShadow: "0 2px 16px rgba(0,0,0,.06)",
                border: "1px solid #f0e9fa",
                position: "sticky", top: 80,
              }}>
                <div style={{ padding: "16px 20px", borderBottom: "1px solid #f5f0fd" }}>
                  <p style={{ margin: 0, fontSize: 14, fontWeight: 700, color: "#2e215c" }}>Order Summary</p>
                </div>
                <div style={{ padding: "8px 20px 20px" }}>
                  <OrderDetails viewCart={viewCart} total={total} />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ── Payment result modal ── */}
        {paymentStatus !== "" && (
          <>
            <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.5)", zIndex: 1040, backdropFilter: "blur(4px)" }} />
            <motion.div
              initial={{ opacity: 0, scale: 0.88, y: 24 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              transition={{ duration: 0.28, ease: [0.16, 1, 0.3, 1] }}
              style={{
                position: "fixed", top: "50%", left: "50%",
                transform: "translate(-50%,-50%)",
                zIndex: 1050, width: "100%", maxWidth: 420, padding: "0 16px",
              }}
            >
              <div style={{
                background: "#fff", borderRadius: 20,
                boxShadow: "0 24px 80px rgba(0,0,0,.22)",
                overflow: "hidden", textAlign: "center",
              }}>
                <div style={{ height: 4, background: paymentStatus.toLowerCase() === "success" ? "linear-gradient(90deg,#22c55e,#4ade80)" : "linear-gradient(90deg,#ef4444,#f87171)" }} />
                <div style={{ padding: "32px 28px 28px" }}>
                  <img
                    src={paymentStatus.toLowerCase() === "success" ? success : decline}
                    alt="Payment Status"
                    style={{ width: 120, margin: "0 auto 16px", display: "block" }}
                  />
                  <h4 style={{
                    fontFamily: "var(--font-display)", fontSize: 22, fontWeight: 600,
                    color: paymentStatus.toLowerCase() === "success" ? "#16a34a" : "#dc2626",
                    margin: "0 0 8px",
                  }}>
                    Payment {paymentStatus.toLowerCase() === "success" ? "Successful" : "Failed"}!
                  </h4>
                  <p style={{ fontSize: 14, color: "#6d6d72", margin: "0 0 24px" }}>
                    {paymentStatus.toLowerCase() === "success" 
                      ? "Your order has been placed successfully. We'll notify you when it's on the way."
                      : "Something went wrong with your payment. Please try again."}
                  </p>
                  <div style={{ display: "flex", gap: 12 }}>
                    <button
                      onClick={() => history("/ProductList")}
                      style={{
                        flex: 1, padding: "12px 0",
                        background: "#f5f5f7", border: "none", borderRadius: 10,
                        fontSize: 13, fontWeight: 600, color: "#4f3267", cursor: "pointer",
                      }}
                    >
                      Shop More
                    </button>
                    <button
                      onClick={clearSuccessData}
                      style={{
                        flex: 1, padding: "12px 0",
                        background: "linear-gradient(135deg,#8217b4,#c48eeb)",
                        border: "none", borderRadius: 10,
                        fontSize: 13, fontWeight: 600, color: "#fff", cursor: "pointer",
                      }}
                    >
                      My Orders
                    </button>
                  </div>
                </div>
              </div>
            </motion.div>
          </>
        )}
      </BgColor>
    </StyledDiv>
  );
}